import { SSOStages } from '../constants';

export default {
  application: {
    ssoStage: SSOStages.PRE_SSO_AUTH,
  },
  sso: {
    ssoExpressEndpointUrl: '',
  },
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js